module.exports = __webpack_public_path__ + "static/media/icons-yc-zoom-out-hover.aa272f96.svg";